<template>
    <div class="de-relation-rank">
        <div class="ott-mobile-body" style="margin-top:20px;">
            <div class="ott-mobile-numer-text">关联数</div>
            <div class="ott-mobile-item ott-mobile-item-title" 
            v-for="(item,index) in titles" 
            :key="index" 
            :style="{'color': item.color && item.color}">
            {{item.name}}</div>
        </div>
        <div
            :key="index"
            class="ott-mobile-body"
            style="margin-top:12px;"
            v-for="(item,index) in data"
        >
            <div class="ott-mobile-serial">{{index+1}}</div>
            <div class="ott-mobile-item">
                <div class="ott-mobile-item-start">{{item.first}}</div>
                <div class="ott-mobile-item-end">
                    <YBar
                        :align="'left'"
                        :is-background="isBackground"
                        :value="item.first"
                        :max-value="20"
                        :size="'large'"
                        style="margin-top:8px;"
                    ></YBar>
                </div>
            </div>
            <div class="ott-mobile-item">
                <div class="ott-mobile-item-start">{{item.sec}}</div>
                <div class="ott-mobile-item-end">
                    <YBar
                        :align="'left'"
                        :color="'green'"
                        :is-background="isBackground"
                        :value="item.sec"
                        :max-value="20"
                        :size="'large'"
                        style="margin-top:8px;"
                    ></YBar>
                </div>
            </div>
            <div class="ott-mobile-item">
                <div
                    class="ott-mobile-item-start"
                    style="padding-left: 4px;width: 40px;">{{item.third}}</div>
                    <div class="ott-mobile-item-end">
                        <YBar
                            :align="'left'"
                            :color="'gray'"
                            :is-background="isBackground"
                            :value="item.third"
                            :max-value="20"
                            :size="'large'"
                            style="margin-top:8px;"
                        ></YBar>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import YBar from './yBar';

export default {
    name: 'de-relation-rank',
    components: {
        YBar
    },
    props: {
        data: {
            type: [Array, Object]
        },
        option1: {
            type: String
        },
        option2: {
            type: String
        },
        option3: {
            type: String
        },
    },
    data() {
        return {
            isBackground: false
        }
    },
    computed: {
        titles() {
            return [{
                name: this.option1
            },{
                name: this.option2,
                color: '#2EE6A8'
            },{
                name: this.option3,
                color: 'rgba(255,255,255,0.50)'
            },]
        }
    }
}
</script>

<style lang="less">
.de-relation-rank {
    padding-bottom: 40px;
    .ott-mobile-body {
        display: flex;
    }
    .ott-mobile-numer-text {
        width: 48px;
        font-family: 'PingFangSC-Regular';
        font-size: 14px;
        color: rgba(255, 255, 255, 0.55);
        letter-spacing: 2px;
        text-align: center;
    }
    .ott-mobile-serial {
        width: 44px;
        height: 18px;
        border: solid 2px rgba(255, 255, 255, 0.25);
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 15px;
    }
    .ott-mobile-item {
        flex: 1;
        padding-left: 23px;
        display: flex;
    }

    .ott-mobile-item-start {
        font-family: AgencyFB-Reg;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 18px;
        padding-left: 5px;
        width: 41px;
        text-align: left;
    }
    .ott-mobile-item-end {
        flex: 1;
    }
    .ott-mobile-item-title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #038cfb;
        letter-spacing: 0;
        line-height: 22px;
    }
}
</style>